import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.t5g().y51() : headers;
  return DelegatedCall().p5i(_this__u8e3s4.o5g_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, originCall, responseContent, responseHeaders) {
        return new.target.p5i(client, originCall, responseContent, responseHeaders);
      }
      static p5i(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.t5g().y51() : responseHeaders;
        var $this = this.q5i(client);
        $this.q5g_1 = new (DelegatedRequest())($this, originCall.r5i());
        $this.r5g_1 = new (DelegatedResponse())($this, originCall.t5g(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.w5i_1 = origin;
        this.x5i_1 = call;
      }
      y5i() {
        return this.x5i_1;
      }
      cw() {
        return this.w5i_1.cw();
      }
      z5i() {
        return this.w5i_1.z5i();
      }
      a5j() {
        return this.w5i_1.a5j();
      }
      s5i() {
        return this.w5i_1.s5i();
      }
      a2o() {
        return this.w5i_1.a2o();
      }
      y51() {
        return this.w5i_1.y51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.y51() : headers;
        super();
        this.b5j_1 = call;
        this.c5j_1 = origin;
        this.d5j_1 = content;
        this.e5j_1 = headers;
        this.f5j_1 = this.c5j_1.cw();
      }
      y5i() {
        return this.b5j_1;
      }
      y51() {
        return this.e5j_1;
      }
      g5j() {
        return this.d5j_1(this.c5j_1);
      }
      cw() {
        return this.f5j_1;
      }
      h5j() {
        return this.c5j_1.h5j();
      }
      i5j() {
        return this.c5j_1.i5j();
      }
      j5j() {
        return this.c5j_1.j5j();
      }
      k5j() {
        return this.c5j_1.k5j();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
